import * as React from 'react';
import { Section, Viewer } from '../../modules';
import { Sample, SampleFactory, Result } from '../../resource/'; 
import { RouteComponentProps } from 'react-router';
import { IAuthProps } from '../../services/Auth';

import { Tabs } from '@independent-software/typeui/controls/Tabs';
import { ToastService } from '@independent-software/typeui/controls/Toast';
import { Flex } from '@independent-software/typeui/controls/Flex';
import { Header } from '@independent-software/typeui/controls/Header';
import { Output } from '../../controls/Output';
import { Datum } from '@independent-software/typeui/formatters/Datum';
import { TidalSituation } from '../Campaign/TidalSituation';
import { ListResults } from '../Result';
import { Label } from '@independent-software/typeui/controls/Label';

class ViewSample extends React.Component<IAuthProps & RouteComponentProps<{id:string}>, {}> {
  private handleEdit = () => {
    this.props.history.push(`/samples/edit/${parseInt(this.props.match.params.id)}`);
  }

  private handleDelete = () => {
    ToastService.toast("Sample deleted.");
    this.props.history.push('/samples');
  }    

  private handleResultClick = (item: Result) => {
    this.props.history.push(`/results/${item.id}`);
  }

  render() {
    let p = this.props;
    return (
      <Viewer<Sample> 
        auth={p.auth}
        id={parseInt(p.match.params.id)}
        factory={SampleFactory}
        canEdit='can_edit_samples'
        canDelete='can_delete_samples'
        onEdit={this.handleEdit}
        onDelete={this.handleDelete}
        content={(sample: Sample) => 
          <React.Fragment>
            <Section dark padded>
              <Header size="h1"><Label>{sample.station.name}</Label> <Label>{sample.campaign.name}</Label> <Label><Datum.ShortDate value={sample.date}/></Label> {sample.time && <Label><Datum.Time value={sample.time}/></Label>}</Header>
            </Section>
            <Tabs underlined>
              <Tabs.Pane label="General">
                <Section padded="very">
                  <Flex.Columns count={2}>
                    <Output label="Campaign" hint="Campaign">{sample.campaign.name}</Output>
                    <Output label="Station" hint="Station">{sample.station.name}</Output>
                    <Output label="Date" hint="Date of sample"><Datum.LongDate value={sample.date}/></Output>
                    <Output label="Depth" hint="Depth from surface at which sample is collected" unit="m">{sample.depth}</Output>
                  </Flex.Columns>
                </Section>
              </Tabs.Pane>
              <Tabs.Pane label="Data">
                <Section padded="very">
                  <Flex.Columns count={2}>
                    <Output label="Time" hint="Time of sample"><Datum.Time seconds value={sample.time}/></Output>
                    <Output label="Sampling interval" hint="Time taken to collect the sample" unit="min">{sample.interval}</Output>
                    <Output label="Tidal situation" hint="Tide condition">{TidalSituation.toName(sample.tidal_situation)}</Output>
                    <Output label="Depth type" hint="Sampling position (e.g. surface, mid-water, bottom)">{sample.depth_type}</Output>
                  </Flex.Columns>
                </Section>
              </Tabs.Pane>              
              <Tabs.Pane label="Results">
                <ListResults sampleId={sample.id} name="sample_results" auth={p.auth} onClick={p.auth.hasRight('can_view_results') && this.handleResultClick}/>
              </Tabs.Pane>
            </Tabs>
          </React.Fragment>}>
      </Viewer>
    );
  }
}

export { ViewSample };
